<!-- TradeInfo.vue -->

<template>
  <el-row class="info-row">
    <el-col>
      <p><strong>Customer Name:</strong> {{ customerName }}</p>
      <p><strong>Date:</strong> {{ currentTimestamp }}</p>
      <p><strong>Total Item Count:</strong> {{ itemCount }} item(s)</p>
      <p>
        <strong>Total Trade-in Offer Credit: </strong>
        ${{ totalTradeInOfferCredit }}
      </p>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "TradeInfoRow",
  props: {
    customerName: String,
    currentTimestamp: String,
    itemCount: Number,
    totalTradeInOfferCredit: String,
  },
};
</script>